{
  "auth.email_signup.email.label": "Email",
  "auth.email_signup.first_name_caption": "You can add a preferred name through your Account later.",
  "auth.email_signup.first_name_on_driver_license.label": "First name on driver's license",
  "auth.email_signup.firstname.required": "First name is required",
  "auth.email_signup.last_name_on_driver_license.label": "Last name on driver's license",
  "auth.email_signup.lastname.required": "Last name is required",
  "auth.email_signup.marketing.label": "Send me promotions and announcements via email",
  "auth.email_signup.marketing.optin_matrix_label": "Send me email updates, recommendations, and deals",
  "auth.email_signup.sms_marketing.label": "Send me promotions and announcements via SMS",
  "auth.email_signup.or_sign_up_with_others": "Or sign up with {#facebookLink}Facebook{/facebookLink} or {#googleLink}Google{/googleLink}",
  "auth.email_signup.password.error_min_length": "Password must be at least 8 characters",
  "auth.email_signup.email.error_format": "Please enter a valid email",
  "auth.email_signup.password.label": "Password",
  "auth.email_signup.sign_up": "Sign up",
  "auth.email_signup.terms_of_service.label": "I agree to the {#termsOfServiceLink}terms of service{/termsOfServiceLink} and {#privacyPolicyLink}privacy policy{/privacyPolicyLink}.",
  "auth.email_signup.title": "Let's get started"
}
